import {
    TOUR_TRIPS_START,
    TOUR_TRIPS_SUCCESS,
    TOUR_TRIPS_ERROR
} from "../Constant/TourInquiryConstant";
  
  const initialState = {
    loading: false,
    trips: [],
  };
  
  export default function TourInquiryReducer( 
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case TOUR_TRIPS_START:
        return {
          ...state,
          trips:[],
          loading: true
        };
      case TOUR_TRIPS_SUCCESS:
        return {
          ...state,
          trips: action.payload,
          loading: false,
        };
      case TOUR_TRIPS_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }